<template>
  <tr>
    <td
      class="boss-table-data"
    >
      <span data-test="file-name">{{ summaryFile.name }}</span>
      <span data-test="file-size">{{ summaryFile.size | formatSize }}</span>
    </td>
    <td
      class="boss-table-data text-center"
      data-test="file-sent"
    >
      {{ summaryFile.sentDate | formatDateTime }}
    </td>
    <td
      class="boss-table-data text-center"
      data-test="file-period"
    >
      {{ summaryFile.expiredDate | formatDate }}
    </td>
    <td
      class="boss-table-data text-center"
      data-test="file-download"
    >
      <template v-if="!summaryFile.manualDeletedDate && !isExpired">
        <button
          class="boss-button"
          data-test="button-download"
          @click="download(summaryFile.id)"
        >
          <span>ダウンロード</span>
        </button>
        <button
          class="boss-button margin-left-1"
          data-test="button-delete"
          @click="doRemove(summaryFile.id)"
        >
          <span>削除</span>
        </button>
      </template>
      <span
        v-else
        data-test="delete-file"
      >
        {{ summaryFile.manualDeletedDate ? `${summaryFile.deletedCompanyStaff}によって${$options.filters.formatDate(summaryFile.manualDeletedDate)}に削除済み` : '閲覧期限終了' }}
      </span>
    </td>
  </tr>
</template>

<script>
import { now, createDate } from '@/lib/dateUtils.js'
import { formatBytes } from '@/lib/formatBytes'
import { downloadUrl } from '@/lib/download'

export default {
  filters: {
    formatSize (size) {
      return size ? `(${formatBytes(size)})` : ''
    },
    formatDateTime (date) {
      return createDate(date)?.format('YYYY/MM/DD(ddd) HH:mm') ?? ''
    },
    formatDate (date) {
      return createDate(date)?.format('YYYY-MM-DD') ?? ''
    }
  },
  props: {
    summaryFile: {
      type: Object,
      required: true
    },
    entryId: {
      type: Number,
      required: true
    }
  },
  computed: {
    isExpired () {
      return now().isAfter(createDate(this.summaryFile.expiredDate), 'days')
    }
  },
  methods: {
    removeFile (fileId) {
      this.$http.secured.put(`/entry/message/entries/${this.entryId}/files/${fileId}`).then(() => {
        this.$toasted.global.success({ message: 'ファイルを削除しました。' })
        this.$emit('fetchAllMessage')
      })
    },
    download (fileId) {
      this.$http.secured.get(`/entry/view/entries/${this.entryId}/files/${fileId}/url`).then((response) => {
        downloadUrl(response.data)
      }).catch(() => {
        // catch句を消すとコンソールに警告が出るから消さないでね！！
      })
    },
    doRemove (fileId) {
      this.$dialog.confirm('応募者のマイページからも削除されますがよろしいですか？')
        // はいを押下した時
        .then(() => {
          // 削除処理追加
          this.removeFile(fileId)
        })
        // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    }
  }
}
</script>
